// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sfSuI","info":"styles_info__Hvu24","imageWrapper":"styles_imageWrapper__28Y0N","image":"styles_image__YbwNY","auto":"styles_auto__iNIg9"};